<template>
  <VisionModal
    :open="visible"
    @close="$emit('update:visible', false)"
  >
    <div :class="$b()">
      <div :class="$b('container')">
        <div :class="$b('inner')">
          <PrescriptionBanner display-style="column" />
        </div>
      </div>
    </div>
  </VisionModal>
</template>

<script>
export default {
  name: 'PrescriptionHowToModal',

  props: {
    visible: { type: Boolean, required: true },
  },

  emits: [
    'update:visible'
  ]
}
</script>

<style lang="postcss">
.PrescriptionHowToModal {
  @apply h-full w-full
    flex flex-col items-center justify-end lg:justify-start
    mx-auto;
}

.PrescriptionHowToModal__container {
  @apply w-full md:w-auto h-full overflow-hidden flex items-end md:items-center;

  flex: 1 1 100%;
}

.PrescriptionHowToModal__inner {
  @apply w-full md:w-auto max-h-full h-auto flex flex-col xs:items-stretch
    bg-white
    overflow-y-auto overflow-x-hidden
    py-16 px-6 md:py-6
    sm:rounded-[10px];
}
</style>
